import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Icons } from '../../icons/Icons';

export const ChatBubble: React.FC = () => {
  const brand = useBrand();
  if (!brand.features.showChatBubble) return null;

  return (
    <button
      aria-label="Chat with support"
      className="fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:scale-105 transition-transform z-50"
      style={{ backgroundColor: brand.colors.primary, color: brand.colors.onPrimary }}
    >
      <Icons.Chat className="w-6 h-6" />
    </button>
  );
};
